<template>
    <b-modal v-model="modal_wizard.show"
             centered
             :title="action_raw_material === 'Crear' ? 'Crear materia prima' : raw_material.raw_material.name"
             size="lg"
             hide-footer
             no-close-on-esc
             no-close-on-backdrop
             hide-header-close
             dialog-class="calculator-dialog"
    >
        <b-row class="mt-2">
            <b-col>
                <el-steps :active="modal_wizard.step"
                          align-center
                >
                    <el-step title="Materia prima"
                             description=""
                    />
                    <el-step title="Componentes"
                             description=""
                    />
                </el-steps>
            </b-col>
        </b-row>

        <b-row class="mt-3">
            <b-col>
                <raw_materials v-if="modal_wizard.step === 0"/>
                <components v-if="modal_wizard.step === 1"/>
            </b-col>
        </b-row>

    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import input_formatter from '../../components/input_formatter.vue';
import raw_materials from './steps/raw_materials.vue';
import components from './steps/components.vue';

export default {
    name: 'wizard',
    components: {
        input_formatter,
        raw_materials,
        components
    },
    computed: {
        ...mapState('calculator', [
            'modal_wizard',
            'raw_material',
            'action_raw_material'
        ])
    },
    methods: {
        ...mapMutations('calculator', [
            'setShowToModalWizard'
        ])
    }
};

</script>
